<template>
  <div class="backgroud-white cs-courseSchedule-editor">
    <div
      v-if="optionModel.showTitle"
      class="text-center"
    >
      <h4>{{isAdd ? '添加学校' : '编辑学校'}}</h4>
    </div>
    <div class="backgroud-gray-popup popup-content-area-small">
      <el-form
        ref="dataModel"
        :rules="rules"
        :model="dataModel"
        label-width="120px"
      >
        <el-form-item
          label="学校名称"
          prop="name"
        >
          <el-input
            @change='onInputChange'
            placeholder="请输入学校名称"
            v-model="dataModel.name"
            class="input-width"
            maxlength="250"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="学校简称"
          prop="abbreviation"
        >
          <el-input
            @change='onInputChange'
            placeholder="请输入学校简称"
            v-model="dataModel.abbreviation"
            class="input-width"
            maxlength="20"
          ></el-input>
        </el-form-item>
        <el-row>
          <el-col class="label-col">&nbsp;</el-col>
          <el-col class="checkbox-col">
            <el-checkbox v-model="dataModel.hasSaturdayCourse">星期六有课？</el-checkbox>
          </el-col>
          <el-col class="checkbox-col">
            <el-checkbox v-model="dataModel.hasSundayCourse">星期天有课？</el-checkbox>
          </el-col>
        </el-row>
        <el-form-item label="同课学校">
          <el-select
            v-model="dataModel.sameGroupUniversityIds"
            placeholder="请选择同课学校"
            multiple
          >
            <el-option
              v-for="item in ungroupedUniversities"
              :key="item.Key"
              :label="item.Value"
              :value="item.Key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="课程总时长"
          prop="totalCourseMinutes"
        >
          <el-input-number
            @change='onInputChange'
            placeholder="请输入学校课程总时长"
            v-model="dataModel.totalCourseMinutes"
            :step="30"
            size="small"
            class="input-width"
          ></el-input-number>
        </el-form-item>
        <el-form-item
          v-if="!isAdd"
          label="状态"
        >
          <el-select
            @change='onInputChange'
            v-model="dataModel.isActive"
            placeholder="请选择状态"
          >
            <el-option
              key="0"
              label="启用"
              :value="true"
            ></el-option>
            <el-option
              key="1"
              label="停用"
              :value="false"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收款接口">
          <el-select v-if="payApiType === GLOBAL.enumPayApiType.AlphaPay"
            v-model="dataModel.alphaPaySettingId"
            placeholder="请选择收款接口"
            clearable
          >
            <el-option
              v-for="item in alphaPaySettingItems"
              :key="item.Value"
              :label="item.Text"
              :value="item.Value"
            ></el-option>
          </el-select>
          <el-select v-else
            v-model="dataModel.checkpaySettingId"
            placeholder="请选择收款接口"
            clearable
          >
            <el-option
              v-for="item in checkpaySettingItems"
              :key="item.Value"
              :label="item.Text"
              :value="item.Value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div
      slot="footer"
      class="dialog-footer popup-footer"
    >
      <el-row>
        <el-col
          :span="20"
          class="footer-left"
        >
          <span v-if="!showError"></span>
          <el-alert
            :closable="false"
            v-if="showError"
            v-bind:title="errorMessage"
            type="error"
            show-icon
          ></el-alert>
        </el-col>
        <el-col
          class="footer-right"
          :span="4"
        >
          <el-button
            :disabled="submitBtnDisable"
            :type="submitBtnClass"
            @click="saveDataToServer"
          >{{isAdd ? '确认添加' : '保存更新'}}</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.label-col {
  width: 120px;
}
.checkbox-col {
  width: 100px;
  margin-left: 10px;
}
</style>

<script>
import {
  getPayApiType,
  getCheckpaySettingItems,
  getAlphaPaySettingItems,
  getNoneGroupUniversity,
  saveUniversity,
} from "../../service/common.service";

export default {
  props: {
    options: {
      showTitle: Boolean
    },
    data: {
      index: Number,
      item: Object
    }
  },
  data() {
    return {
      isAdd: true,
      submitBtnClass: "primary",
      submitBtnDisable: false,
      showError: false,
      errorMessage: "",
      payApiType: 0,
      checkpaySettingItems: [],
      alphaPaySettingItems: [],
      sameGroupUniversities: [],
      ungroupedUniversities: [],
      optionModel: {
        showTitle: false
      },
      dataModel: {
        index: -1,
        id: 0,
        name: null,
        abbreviation: null,
        hasSaturdayCourse: false,
        hasSundayCourse: false,
        isActive: true,
        sameGroupUniversityIds: [],
        groupNumber: 0,
        totalCourseMinutes: 0,
        checkpaySettingId: null,
        alphaPaySettingId: null
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入学校名称",
            trigger: "blur"
          },
          {
            min: 0,
            max: 250,
            message: "最大长度在为250个字符",
            trigger: "blur"
          }
        ],
        abbreviation: [
          {
            required: true,
            message: "请输入学校简称",
            trigger: "blur"
          },
          {
            min: 0,
            max: 20,
            message: "最大长度在为20个字符",
            trigger: "blur"
          }
        ],
        totalCourseMinutes: [
          {
            required: true,
            message: "请输入学校课程总时长",
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {
    this.loadOptionModelFromProps();
    this.initData();
  },
  methods: {
    async loadPayApiTypeFromServer() {
      let value = 0;

      try {
        let result = await getPayApiType();
        if (!!result && result.success) {
          value = result.data;
        }
      } catch (error) {
        console.error(error);
      }

      this.payApiType = value;
    },
    async loadCheckpaySettingItemsFromServer() {
      let dataList = [];

      try {
        let result = await getCheckpaySettingItems();
        if (!!result && result.success) {
          dataList = result.data;
        }
      } catch (error) {
        console.error(error);
      }

      this.checkpaySettingItems = dataList;
    },
    async loadAlphaPaySettingItemsFromServer() {
      let dataList = [];

      try {
        let result = await getAlphaPaySettingItems();
        if (!!result && result.success) {
          dataList = result.data;
        }
      } catch (error) {
        console.error(error);
      }

      this.alphaPaySettingItems = dataList;
    },
    async loadUngroupedUniversitiesFromServer() {
      let dataList = [];

      let result = await getNoneGroupUniversity();
      if (!!result && result.success) {
        result.data.forEach(element => {
          if (this.isAdd || element.Id != this.dataModel.id)
            dataList.push({
              Key: element.Id,
              Value: element.Name
            });
        });
      }

      this.ungroupedUniversities = dataList;
    },
    loadOptionModelFromProps(options = this.options) {
      if (!!options) {
        this.optionModel.showTitle = options.showTitle;
      } else {
        this.optionModel.showTitle = false;
      }
    },
    loadDataFromProps(data = this.data) {
      if (!!data) {
        this.dataModel.index = data.index;
      } else {
        this.dataModel.index = -1;
      }

      if (!!data && !!data.item && !!data.item.Id) {
        let sameGroupUniversities = $.extend(
          true,
          [],
          data.item.SameGroupUniversities
        );
        let sameGroupUniversityIds = this.__getUniversityIds(
          sameGroupUniversities
        );

        this.sameGroupUniversities = sameGroupUniversities;
        this.dataModel.index = data.index;
        this.dataModel.id = data.item.Id;
        this.dataModel.name = data.item.Name;
        this.dataModel.abbreviation = data.item.Abbreviation;
        this.dataModel.hasSaturdayCourse = data.item.HasSaturdayCourse;
        this.dataModel.hasSundayCourse = data.item.HasSundayCourse;
        this.dataModel.isActive = data.item.IsActive;
        this.dataModel.sameGroupUniversityIds = sameGroupUniversityIds;
        this.dataModel.groupNumber = data.item.GroupNumber;
        this.dataModel.totalCourseMinutes = data.item.TotalCourseMinutes;
        this.dataModel.checkpaySettingId = data.item.CheckpaySettingId;
        this.dataModel.alphaPaySettingId = data.item.AlphaPaySettingId;
      } else {
        this.sameGroupUniversities = [];
        this.dataModel.index = -1;
        this.dataModel.id = 0;
        this.dataModel.name = null;
        this.dataModel.abbreviation = null;
        this.dataModel.hasSaturdayCourse = false;
        this.dataModel.hasSundayCourse = false;
        this.dataModel.isActive = true;
        this.dataModel.sameGroupUniversityIds = [];
        this.dataModel.groupNumber = 0;
        this.dataModel.totalCourseMinutes = 720;
        this.dataModel.checkpaySettingId = null;
        this.dataModel.alphaPaySettingId = null;
      }

      this.dataModel._originalData = Object.clone(this.dataModel);

      if (this.$refs["dataModel"]) this.$refs["dataModel"].clearValidate();

      if (this.dataModel.index >= 0) {
        this.isAdd = false;
        this.submitBtnClass = "primary";
        this.submitBtnDisable = false;
      } else {
        this.isAdd = true;
        this.submitBtnClass = "info";
        this.submitBtnDisable = true;
      }
      this.showError = false;
      this.message = "";
    },
    async saveDataToServer() {
      let isValid = this.checkAllInputs(true);
      if (!isValid) return;

      this.submitBtnDisable = true;
      this.showError = false;
      this.errorMessage = "";
      let saveModel = this.getDataOut().item;
      let result = await saveUniversity(saveModel);
      if (!!result && result.success) {
        this.$message({
          message: "保存成功",
          type: "success"
        });
        this.dataModel.id = result.data;
        this.triggerSaveSuccess();
        this.triggerClose();
      } else {
        this.errorMessage = !!result ? result.message : "未连接到服务器";
        this.showError = true;
      }
      this.submitBtnDisable = false;
    },
    checkAllInputs(onlyCheck = false) {
      let isValid = true;
      if (!this.$refs["dataModel"]) return false;
      this.$refs["dataModel"].validate(valid => {
        if (!valid) {
          isValid = false;
        }
      });
      if (onlyCheck) return isValid;
      this.submitBtnClass = isValid ? "primary" : "info";
      this.submitBtnDisable = !isValid;
      return isValid;
    },
    async initData(data = this.data) {
      this.loadDataFromProps(data);
      await this.loadPayApiTypeFromServer();
      await this.loadCheckpaySettingItemsFromServer();
      await this.loadAlphaPaySettingItemsFromServer();
      await this.loadUngroupedUniversitiesFromServer();
      this.__mergeUngroupedUniversities(this.sameGroupUniversities);
    },
    onInputChange(value) {
      this.checkAllInputs();
    },
    getDataOut() {
      let sameGroupUniversities = this.__getSameGroupUniversities(
        this.dataModel.sameGroupUniversityIds
      );
      let sameGroupUniversitiesText = this.__getUniversitiesText(
        sameGroupUniversities
      );
      let item = {
        Id: this.dataModel.id,
        Name: this.dataModel.name,
        Abbreviation: this.dataModel.abbreviation,
        HasSaturdayCourse: this.dataModel.hasSaturdayCourse,
        HasSundayCourse: this.dataModel.hasSundayCourse,
        IsActive: this.dataModel.isActive,
        Active: this.dataModel.isActive ? "启用" : "停用",
        SameGroupUniversities: sameGroupUniversities,
        SameGroupUniversitiesText: sameGroupUniversitiesText,
        GroupNumber: this.dataModel.groupNumber,
        TotalCourseMinutes: this.dataModel.totalCourseMinutes,
        CheckpaySettingId: this.dataModel.checkpaySettingId || null,
        AlphaPaySettingId: this.dataModel.alphaPaySettingId || null
      };
      let needReload = !Object.valueEquals(this.dataModel, this.dataModel._originalData, {
        exceptFields: ["_originalData"]
      });
      let dataOut = {
        index: this.dataModel.index,
        item: item,
        needReload
      };
      return dataOut;
    },
    triggerSaveSuccess(id) {
      let dataOut = this.getDataOut();
      this.$emit("saveSuccess", dataOut);
    },
    triggerClose() {
      this.$emit("closeDialog");
    },
    __getUniversityIds(universities) {
      let ids = [];

      if (!universities || universities.length <= 0) return ids;

      universities.forEach(element => {
        ids.push(element.Key);
      });

      return ids;
    },
    __getUniversitiesText(universities) {
      let text = "";

      if (!universities || universities.length <= 0) return text;

      universities.forEach(element => {
        if (!!text) text += "\r\n";
        text += element.Value;
      });

      return text;
    },
    __getSameGroupUniversities(universityIds) {
      let sameGroupUniversities = [];

      if (!universityIds || universityIds.length <= 0)
        return sameGroupUniversities;

      universityIds.forEach(element => {
        let university = this.__getItemFromUngroupedUniversities(element);
        if (!!university) sameGroupUniversities.push(university);
      });

      return sameGroupUniversities;
    },
    __getItemFromUngroupedUniversities(key) {
      let result = null;

      for (let i = 0; i < this.ungroupedUniversities.length; i++) {
        let university = this.ungroupedUniversities[i];
        if (university.Key == key) {
          result = university;
          break;
        }
      }

      return result;
    },
    __mergeUngroupedUniversities(universities) {
      if (!universities || universities.length <= 0) return;

      for (let i = 0; i < universities.length; i++) {
        let university = universities[i];
        if (!!this.__getItemFromUngroupedUniversities(university.Key)) continue;

        this.ungroupedUniversities.push(university);
      }
    }
  },
  watch: {
    options: function(newVal) {
      this.loadOptionModelFromProps(newVal);
    },
    data: function(newVal) {
      this.initData(newVal);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/universityManagement/universityEdit.vue